import { render, staticRenderFns } from "./SpTwoModule5.vue?vue&type=template&id=35a711e8&scoped=true"
import script from "./SpTwoModule5.vue?vue&type=script&lang=js"
export * from "./SpTwoModule5.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule5.vue?vue&type=style&index=0&id=35a711e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a711e8",
  null
  
)

export default component.exports